function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("radialGradient", {
  cx: "100%",
  cy: "0.836572506%",
  fx: "100%",
  fy: "0.836572506%",
  r: "106.967246%",
  gradientTransform: "translate(1.000000,0.008366),scale(0.526317,1.000000),rotate(152.637928),translate(-1.000000,-0.008366)",
  id: "radialGradient-1"
}, React.createElement("stop", {
  stopColor: "#FFE72E",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFAD2F",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "About-_-Modal-View",
  transform: "translate(75.000000, -1312.000000)"
}, React.createElement("g", {
  id: "Background",
  transform: "translate(-75.000000, -23.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(204.000000, 1401.500000) scale(-1, 1) translate(-204.000000, -1401.500000) translate(0.000000, 1335.000000)"
}, React.createElement("path", {
  d: "M305.087865,10.5209712 C290.590181,19.8483537 271.7899,19.8483537 257.292216,10.5209712 C247.057606,3.93503439 234.89536,0.0851536842 221.840258,0.00251508772 C185.380469,-0.229232281 155.838967,28.4176168 155.005395,64.8666274 C154.148469,102.262389 184.205564,132.845855 221.407304,132.845855 C234.555823,132.845855 246.80969,129.026515 257.125142,122.435189 C271.856371,113.017982 290.521914,113.017982 305.256735,122.435189 C315.568595,129.026515 327.822462,132.845855 340.970981,132.845855 C378.170925,132.845855 408.231613,102.260592 407.374686,64.8666274 C406.542911,28.5631326 377.233156,0.00251508772 340.978167,0.000718596492 C340.832651,0.000718596492 340.687135,0.00251508772 340.539823,0.00251508772 C327.484721,0.0851536842 315.322476,3.93683088 305.087865,10.5209712 Z",
  id: "Fill-7",
  fill: "url(#radialGradient-1)",
  transform: "translate(281.190040, 66.423287) scale(-1, 1) translate(-281.190040, -66.423287) "
}), React.createElement("path", {
  d: "M132.845137,66.4234667 C132.845137,103.107818 103.106021,132.846933 66.4216702,132.846933 C29.7373193,132.846933 -2.98427949e-13,103.107818 -2.98427949e-13,66.4234667 C-2.98427949e-13,29.7391158 29.7373193,-7.10542736e-14 66.4216702,-7.10542736e-14 C103.106021,-7.10542736e-14 132.845137,29.7391158 132.845137,66.4234667",
  id: "Fill-4",
  fill: "#FFAD2F"
})))));

var SvgMetaphor2 = function SvgMetaphor2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "408px",
    height: "133px",
    viewBox: "0 0 408 133",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMetaphor2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metaphor2.d64b26c1.svg";
export { ForwardRef as ReactComponent };